export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_10.f6ab0dd3.jpg";